/** Une seule vague d’archivage INBOX auto par compte / rechargement (évite relances en boucle). */
const kickedAccounts = new Set<number>();
const inflightAccounts = new Set<number>();

export function markInboxArchiveKicked(accountId: number): boolean {
  if (kickedAccounts.has(accountId) || inflightAccounts.has(accountId)) {
    return false;
  }
  kickedAccounts.add(accountId);
  return true;
}

export function markInboxArchiveInflight(accountId: number, active: boolean): void {
  if (active) {
    inflightAccounts.add(accountId);
  } else {
    inflightAccounts.delete(accountId);
  }
}

export function isInboxArchiveInflight(accountId?: number): boolean {
  if (accountId == null) {
    return inflightAccounts.size > 0;
  }
  return inflightAccounts.has(accountId);
}

export function resetInboxArchiveSession(accountId?: number): void {
  if (accountId == null) {
    kickedAccounts.clear();
    inflightAccounts.clear();
    return;
  }
  kickedAccounts.delete(accountId);
  inflightAccounts.delete(accountId);
}
